import { createFileRoute } from '@tanstack/react-router'
import { ChatBotPage } from '@/Chat/ChatBotPage'
export const Route = createFileRoute('/chat/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ChatBotPage />
}
